import React from 'react';
import { connect } from 'react-redux';

function ObrotFooter(props) {

  var phoneResult = props.user_phone.substr(0, 3) + " " + props.user_phone.substr(3, 3) + " " + props.user_phone.substr(6, 3);
    return (
    <>
      <div id="divtocopy">
        <table cellPadding="0" width="520" style={{verticalAlign: "-webkit-baseline-middle"}}>
          <tbody>
          <tr>
            <td>
              <table width="100%">
                <tbody>
                <tr>
                  <td style={{width:"180px", textAlign:"left"}}>
                      <table cellPadding="0" width="180">
                        <tbody>
                          <tr>
                            <td width="180">
                              <img style={{verticalAlign:"middle",borderRadius:'6px'}} src={props.user_image} alt="avatar" width="135"/>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </td>
                  <td style={{color:"rgb(0, 0, 0)",verticalAlign:"top"}}>
                    <table>
                      <tbody>
                          <tr>
                            <td>
                            <h1 style={{fontFamily:"Arial",margin:"0", fontWeight:"400",fontSize:"28px"}}>
                                {props.user_name}
                                <span style={{fontSize:"28px",fontFamily:"Arial",fontWeight:"700"}}>
                                  &nbsp;{props.user_surname}
                                </span>
                              </h1>
                              <h4 id="titleField" style={{fontFamily:"Arial",fontWeight:"normal",margin:"0",padding:"0 0 25px",fontSize:"14px",color:"#5592B5"}}>
                                {props.user_position}
                              </h4>
                            </td>
                          </tr>
                          <tr>
                            <td height='35'></td>
                          </tr>
                          <tr>
                            <td width="350">
                              <table>
                                <tbody>
                                <tr>
                                  <td>
                                  {!props.user_phone ? (
                                      <span></span>
                                    ) : (
                                    <>
                                      <img style={{verticalAlign:"bottom",width:"17px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/b-phone.png" alt=""/>
                                      &nbsp;<span style={{fontFamily:"Arial",lineHeight:"16px",fontWeight:"400",fontSize:"14px",padding:"0 0 0 6px",display:"inline-block"}}>
                                        +48 {phoneResult}
                                      </span>
                                    </>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td width='350'>
                                    <img style={{verticalAlign:"middle", width:"17px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/b-mail.png" alt=""/>
                                    &nbsp;<span style={{fontFamily:"Arial",margin:"0",lineHeight:"16px",fontWeight:"400",fontSize:"14px",paddingLeft:"6px",display:"inline-block"}}>
                                      {props.user_email}
                                    </span>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                  </td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr style={{height:"25px",verticalAlign:"middle"}}>
                  <td>
                    <hr size="1" color="#DFEAF3"></hr>
                  </td>
              </tr>
          <tr>
            <td>
              <table>
                <tbody>
                <tr>
                  <td width='200'>
                    <table style={{borderSpacing: "0"}}>
                      <tbody>
                      <tr>
                        <td>
                          <img src="https://columbusenergy.pl/lp/stopka/generator/assets/logo-obrot.png" alt="" style={{verticalAlign:"middle",width:"40px"}}/>
                        </td>
                        <td width='200' style={{lineHeight:"13px",fontSize:"10px",fontFamily:"Arial",color:"rgb(0, 0, 0)",fontWeight:"400",padding:"0 0 0 15px"}}>
                          <span style={{color:"#000",fontSize:"10px",fontWeight:"700",verticalAlign: "middle"}}>
                            Columbus Obrót Sp. z o.o.
                          </span>
                            <br />ul. Pana Tadeusza 4
                            <br />30-727 Kraków
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table style={{borderSpacing: "0"}}>
                      <tbody>
                      <tr>
                        <td id="company" style={{width:"200px",lineHeight:"13px",fontSize:"10px",fontFamily: "Arial",color:"rgb(0, 0, 0)",fontWeight:"400",padding:"0"}}>
                          NIP: 949-216-31-54
                          <br/>biuro@columbusenergy.pl
                          <br/>tel. 12 307 30 96
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table width='150' style={{borderSpacing:"0"}}>
                      <tbody>
                      <tr>
                        <td width='12' align="right"style={{textAlign:"right"}}>
                          <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.linkedin.com/company/columbusenergy">
                            <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/b-in.png" alt=""/>
                        </a>
                        </td>
                        <td width='12' align="right" style={{textAlign:"right"}}>
                          <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.youtube.com/channel/UCpk-ain20Of43QA-_GDTI8g">
                            <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/b-yt.png" alt=""/>
                          </a>
                        </td>
                        <td width='12' align="right" style={{textAlign:"right"}}>
                          <a style={{display:"inline-block", textDecoration: "none"}} href="https://pl-pl.facebook.com/columbusenergysa">
                            <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/b-fb.png" alt=""/>
                          </a>
                        </td>
                        <td width='12' align="right" style={{textAlign:"right"}}>
                          <a style={{display:"inline-block", textDecoration:"none"}} href="https://columbusenergy.pl/">
                            <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/b-web.png" alt=""/>
                          </a>
                        </td>
                        <td width='12' align="right" style={{textAlign:"right"}}>
                          <a style={{textDecoration: "none"}} href="https://www.instagram.com/columbusenergy/">
                            <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/b-inst.png" alt=""/>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          {/* <tr style={{verticalAlign:"middle"}}>
              <td>
                <p style={{fontFamily:"Arial",fontStyle: "normal",fontWeight: "normal",fontSize: "7px",lineHeight: "8px",color: "#787878",marginTop: "20px"}}>
                  Administratorem Państwa danych osobowych jest Columbus Energy S.A. 
                  z siedzibą w Krakowie. Państwa dane osobowe mogą być przetwarzane 
                  w celach takich jak na przykład wykonanie umowy lub skontaktowanie 
                  się z Państwem. Przysługują Państwu wszystkie prawa wynikające z RODO, 
                  w tym prawa: dostępu do danych, ich sprostowania, usunięcia, ograniczenia 
                  przetwarzania, wniesienia sprzeciwu wobec przetwarzania, przenoszenia 
                  danych, wniesienia skargi. Szczegółowe informacje na temat przetwarzania 
                  danych osobowych znajdują się 
                  <a href='https://columbusenergy.pl/relacje-inwestorskie/regulacje/' 
                  style={{color:"#fd5600",textDecoration:"underline",fontSize:"7px"}}> tutaj</a>.
                  Columbus Energy zarejestrowana 
                  w Sądzie Rejonowym dla Krakowa-Śródmieścia w Krakowie XI Wydział Gospodarczy, 
                  KRS pod numerem 0000373608, NIP: 949-216-31-54, REGON: 241811803, BDO: 000258633 
                  z kapitałem zakładowym 129.982.198,50 zł (wpłaconym w całości).
                </p>
              </td>
          </tr> */}
          </tbody>
        </table>
      </div>
    </>
    );
}

function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
    user_image: state.user_reducer.user_image,
  }
}
export default connect(mapStateToProps)(ObrotFooter);